import React from "react";
import { useState, useEffect, useContext } from "react";
import { useSelector, useDispatch } from "react-redux";
import "react-data-table-component-extensions/dist/index.css";
import DataService from ".././../services/tutorial.service";
import "react-confirm-alert/src/react-confirm-alert.css";
import * as AiIcons from "react-icons/ai";
import "react-toastify/dist/ReactToastify.css";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import "react-datepicker/dist/react-datepicker.css";
import Navigationtitle from "../include/Navigationtitle";
import { Image, Shimmer } from "react-shimmer";
import LoadingOverlay from "react-loading-overlay-ts";
import { actlistData, joinAuction,actmore } from "../../actions/index";
import { useForm } from "react-hook-form";
import { BASE_PATH } from ".././../constants/Global";
import { Link, useHistory } from "react-router-dom";
import dateFormat from "dateformat";
import { auctiondefaultLogo } from "../../constants/Images";
import NotFound from "../include/NotFound";
import BounceLoader from "react-spinners/ClipLoader";
import { maxStringNew } from "../../Helpers/Helpers";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faTrash } from '@fortawesome/free-solid-svg-icons'
import { faPenToSquare } from '@fortawesome/free-solid-svg-icons'
import { FirebaseContext } from '../../FirebaseContext';

function JoinauctionCode(match) {
    const {
        register,
        handleSubmit,
        formState: { errors },
    } = useForm();
    const dispatch = useDispatch();
    const [data, setData] = useState([]);
    const [joindata, setjoindata] = useState([]);
    const [isActive, setActive] = useState(false);
    const getpageData = useSelector((state) => state.setactlistData);
    const loginuser = useSelector((state) => state.setUserlog);
    const { upddata } = useContext(FirebaseContext);
    const isfirsttime = useSelector((state) => state.isfirsttime);
    const getaucpageData = useSelector((state) => state.setactlistData);
    const aucmoredetail = useSelector((state) => state.actmoredata);

    const [isDisabled, setDisabled] = useState(false);
    const refresh = useSelector((state) => state.setRefresh);
    const history = useHistory({ forceRefresh: true });
    const [cid, setCid] = useState(loginuser["cid"]);
    const [customcount, setcustomcount] = useState(0);
    const [cuss, setcuss] = useState('0');
    const [cusreq, setcusreq] = useState('0');
    const [cusl, setcusl] = useState('');
    const [cuslist, setcuslist] = useState([]);
    const [selectedOption, setSelectedOption] = useState('');
    const [isoptpopup, setisoptpopup] = useState(false)
    const [optval, setoptval] = useState("")

    const aid = localStorage.getItem("auction_id");

    const ls = ['age', 'fname', 'cat', 'detail', 'tname', 'tno', 'tshirt', 'trouser', 'icon', 'sp1', 'sp2', 'sp3', 'receipt'];
    const initiallOptions = Object.fromEntries(
        ls.map((l, index) => [l, { s: "1", r: "0", l: "", k: index + 1 }])
    );
    const [field, setfield] = useState(initiallOptions);
    const [customfield, setcustomfield] = useState([]);
    const onSubmit = (values) => {

        setDisabled(true);
        const id = toast.loading("Please wait...");
        let toastContainerId = toast.update(id, {
            render: "please wait...",
            theme: "dark",
        });

        var hdr = {
            headers: {
                "Content-Type": "application/x-www-form-urlencoded",
                Authorization: JSON.stringify([{ cid: cid, token: loginuser["token"] }]),
            },
        };
        DataService.JoinauctionCode(values, hdr)
            .then((res) => {
                let response = res.data;


                toast.dismiss(toastContainerId);

                dispatch(joinAuction({ response, values }));

                if (response.success == true) {
                    if (response.data.detail.reg_player_on === "1") {
                        localStorage.setItem("auction_id", response.data.detail.aid);

                        toast.success("Now you can Join", {
                            theme: "dark",
                            position: "bottom-center",
                        });
                        history.push(BASE_PATH + "join-auction");
                    }
                    else {
                        setjoindata(response.data.detail)
                    }


                } else {
                    toast.error(response.msg, { theme: "colored" });
                }

                // setDisabled(false);
            })
            .catch(() => {
                console.log("Not valid");
                toast.dismiss(toastContainerId);
                toast.error("Not valid Server Error", { theme: "colored" });
                setDisabled(false);
            });
        localStorage.removeItem('acode')
    };

    const fetchData = async () => {
        // localStorage.removeItem('auction_id')

        setActive(true);
        console.log("fetch cid:" + cid);
        var hdr = {
            headers: {
                "Content-Type": "application/x-www-form-urlencoded",
                Authorization: JSON.stringify([{ cid: cid, token: loginuser["token"] }]),
            },
        };
        console.log(aid)
        await DataService.plrforminfo({ 'aid': aid }, hdr)
            .then((res) => {
                let response = res.data;
                console.log("response");
                console.log(response);


                if (response.success == true) {

                    //   let responsedata = response.data;
                    //   setData(responsedata);

                    //   dispatch(actlistData({ responsedata }));
                    setData(response.data)
                    // console.log(field)
                    if (response.data.cf !== "") {

                        setcuslist(response.data.cf)
                    }
                    response.data.df.map((ele) => {
                        console.log("ele")
                        Object.entries(field).forEach(([key, value]) => {
                            // console.log(key)
                            if (ele.k == value.k) {
                                setfield(prevObjects => {
                                    return {
                                        ...prevObjects,
                                        [key]: ele
                                    };
                                })
                            }
                        });
                        // field.forEach(obj => {
                        //     // console.log(obj)
                        //     for (const key in obj) {
                        //         console.log(obj[key])
                        //         console.log(key)
                        //         if(ele.k==obj[key].k){
                        //             setfield(prevObjects => {
                        //                 const newObjects = [...prevObjects]; 
                        //                 newObjects[key]=ele; 
                        //                 console.log("newObjects")
                        //                 console.log(newObjects)
                        //                 return newObjects; // Return the updated array
                        //             })
                        //         }
                        //     }
                        // });
                    })
                }

                setActive(false);
            })
            .catch(() => {
                console.log("Not valid");
                setActive(false);
            });

    };

    useEffect(() => {
        fetchData()
        if (refresh == 1) {

            // fetchData(0);
        } else {
            if (getpageData == 0) {

                // fetchData(0);
            } else {
                if (getpageData.responsedata.cid == cid) {

                    // fetchData(0)
                    // setData(getpageData.responsedata);
                } else {
                    let responsedata = getpageData.responsedata;
                    responsedata.list = [];
                    // setData(responsedata);
                    // fetchData(0);
                }
            }
        }
        if (localStorage.getItem('acode')) {
            var values = {
                'acode': localStorage.getItem('acode')
            }
            onSubmit(values);

        }

        window.scrollTo(0, 0);
    }, [refresh]);
    const handleOptionChange = (event) => {
        if (event.target.value)
            setSelectedOption(event.target.value);
    };
    const firechange = (datasnap) => {
        if (datasnap.type == "1" && datasnap.upd == "3") {
            if (getaucpageData != 0) {
                const updateitem = getaucpageData.responsedata.list.filter((ele) => ele.aid != datasnap.id)

                let responsedata = {
                    responsedata: {
                        path: getaucpageData.responsedata.path,
                        cid: cid,
                        list: updateitem,
                    },
                };
                dispatch(actlistData(responsedata));
            }
            history.push(BASE_PATH + 'my-auction')
        }
    }
    useEffect(() => {
        if (upddata !== null) {
            if (upddata !== isfirsttime) {
                firechange(upddata);
                if (upddata.upd == "4") {
                    dispatch(setisfirsttime(upddata));
                }
            }
        }
    }, [upddata]);
    function choosedauction(code) {
        var values = {
            'acode': code
        }
        onSubmit(values);
    }
    function handlechange(l, option, val) {
        setfield((prevlOptions) => ({
            ...prevlOptions,
            [l]: { ...prevlOptions[l], [option]: val },
        }));

    }
    function handlecustomchange(l, option, val) {
        setcustomfield((prevlOptions) => ({
            ...prevlOptions,
            [l]: { ...prevlOptions[l], [option]: val },
        }));
    }



    const postfield = async () => {
        setActive(true);
       
        var hdr = {
            headers: {
                "Content-Type": "application/x-www-form-urlencoded",
                Authorization: JSON.stringify([{ cid: cid, aid: aid, token: loginuser["token"] }]),
            },
        };


        var farr = []

        ls.map((ele) => {

            farr.push(field[ele])
        })
        console.log(farr)
        // var cusfarr=[]
        // ls.map((ele)=>{
        //     // console.log(field[ele].l)
        //     if(customfield[ele].l==""){
        //         console.log('condition hit')
        //         field[ele].l=ele
        //     }
        //     farr.push(field[ele])
        // })
        console.log("customfield")
        console.log(customfield)
        console.log(cuslist)
        let exitFunction = false;
        cuslist.map((ele) => {
            if (ele.t && ele.t == '2') {
                if (ele.o == undefined) {
                    alert('Set options for ' + ele.l)
                     exitFunction = true;
                    return
                }
            }
        })
        if (exitFunction) {
            // toast.dismiss(toastContainerId);

            return; // Exit the function
        }
        const id = toast.loading("Please wait...");
        cuslist.map((ele) => {
            if (ele.t==undefined) {
               ele.t='0'
            }
        })
        // console.log('newcuslist')
        // console.log(newcuslist)
        let toastContainerId = toast.update(id, {
            render: "please wait...",
            theme: "dark",
            position: "bottom-center",
        });

        var val = {}
        const jsonString = JSON.stringify(farr);
        const jsonString2 = JSON.stringify(cuslist);

        val.df_f = jsonString
        val.custom_f = jsonString2

        console.log(val)
        console.log(cuslist)
        await DataService.setplrform(val, hdr)
            .then((res) => {
                let response = res.data;
                console.log("custom resp")
                console.log(response)
                toast.dismiss(toastContainerId);

                if (response.success == true) {
                    if(aucmoredetail !=0){
                        console.log('kkkk')
                      aucmoredetail.extra=cuslist
                      console.log('kkkk22')

                      dispatch(actmore(aucmoredetail))
                      console.log('kkkk33')

                    }
                     console.log("succcessss")
                    toast.success("Updated successfully", {
                        theme: "dark",
                        position: "bottom-center",
                    });

                } else {

                    if (response.msg != "")
                        toast.error(response.msg, { theme: "colored" });
                }

                setActive(false);
            })
            .catch(() => {
                console.log("Not valid");
                toast.error("Not valid Server Error", { theme: "colored" });
                setActive(false);
            });
    };
    function updcustlbl(i, v) {
        const updatedList = cuslist.map((ele, index) =>
            index === i ? { ...ele, l: v } : ele
        );
        console.log(updatedList)
        setcuslist(updatedList)
    }
    function updcustreq(i, v) {
        const updatedList = cuslist.map((ele, index) =>
            index === i ? { ...ele, r: v } : ele
        );
        setcuslist(updatedList)
        console.log(updatedList)

    }
    function updinptype(i, v) {
        setSelectedOption(v)
        if (v == 2) {

            setisoptpopup(true)
        }
        else {
            setisoptpopup(false)

        }
        const updatedList = cuslist.map((ele, index) =>
            index === i ? { ...ele, t: v } : ele
        );
        setcuslist(updatedList)
        console.log(updatedList)

    }
    function updcusts(i, v) {
        const updatedList = cuslist.map((ele, index) =>
            index === i ? { ...ele, s: v } : ele
        );
        setcuslist(updatedList)
    }
    function updopt(i, v) {
        const updatedList = cuslist.map((ele, index) =>
            index === i ? { ...ele, o: v } : ele
        );
        setcuslist(updatedList)
        setisoptpopup(false)
    }
    function addcustomfield() {
        setcuslist((prev) => [...prev, { 's': '0', 'r': '0', 'l': '' }])

    }
    function delcustom(i) {

        const updatedList = cuslist.filter((ele, index) => index !== i)
        setcuslist(updatedList)
    }
    return (
        <>

            <loadingOverlay
                active={isActive}
                spinner={<BounceLoader color={"#337ab7"} />}
            >
                <div>
                    <Navigationtitle data={match} />
                    {isoptpopup && <div className="optionpopup">

                    </div>}
                    <div className="joincustommain">
                        <div className="joincuscontent">
                            <div>
                                {/* <h3>Fields to be set</h3> */}
                            </div>



                            {/* <div className="deffields">
                                <div className="deffieldssub mainl">
                                    <label for="coding">Age :</label>
                                </div>
                                <div className="deffieldssub">
                                    <label for="coding">Show</label>
                                    <input type="checkbox" id="coding" checked={field.age.s == "1" ? true : false} name="interest" onChange={(e) => handlechange('age', 's', e.target.checked ? "1" : "0")} />

                                </div>
                                <div className="deffieldssub">
                                    <label for="coding">Is required</label>
                                    <input type="checkbox" id="coding" checked={field.age.r == "1" ? true : false} name="interest" onChange={(e) => handlechange('age', 'r', e.target.checked ? "1" : "0")} />

                                </div>
                                <div className="deffieldssub inptext">
                                    <label for="coding">Change label name</label>
                                    <input type="text" id="coding" name="interest" value={field.age.l} onChange={(e) => handlechange('age', 'l', e.target.value)} />

                                </div>
                            </div> */}
                            <div className="deffieldsmain defshadow">
                                <div className="newdeffields">
                                    <div className="fieldflex" >
                                        <div className="deffieldssub mainl">
                                            <label for="coding">Age :</label>
                                        </div>
                                        <div className="deffieldssub">
                                            <label for="coding1">Show</label>
                                            <input type="checkbox" id="coding1" checked={field.age.s == "1" ? true : false} name="interest" onChange={(e) => handlechange('age', 's', e.target.checked ? "1" : "0")} />
                                        </div>
                                        <div className="deffieldssub">
                                            <label for="coding2">Is required</label>
                                            <input type="checkbox" id="coding2" checked={field.age.r == "1" ? true : false} name="interest" onChange={(e) => handlechange('age', 'r', e.target.checked ? "1" : "0")} />
                                        </div>
                                    </div>
                                    <div className="fieldflex">
                                        <div className="deffieldssub inptext">
                                            <label for="coding">Change label name</label>
                                            <input type="text" id="coding" name="interest" value={field.age.l} onChange={(e) => handlechange('age', 'l', e.target.value)} />
                                        </div>
                                    </div>
                                </div>
                                <div className="newdeffields">
                                    <div className="fieldflex" >

                                        <div className="deffieldssub mainl">
                                            <label for="coding">Father's name :</label>
                                        </div>
                                        <div className="deffieldssub">
                                            <label for="coding3">Show</label>
                                            <input type="checkbox" id="coding3" checked={field.fname.s == "1" ? true : false} name="interest" value="coding" onChange={(e) => handlechange('fname', 's', e.target.checked ? "1" : "0")} />

                                        </div>
                                        <div className="deffieldssub">
                                            <label for="coding4">Is required</label>
                                            <input type="checkbox" id="coding4" checked={field.fname.r == "1" ? true : false} name="interest" value="coding" onChange={(e) => handlechange('fname', 'r', e.target.checked ? "1" : "0")} />

                                        </div>
                                    </div>
                                    <div className="deffieldssub inptext">
                                        <label for="coding">Change label name</label>
                                        <input type="text" id="coding" name="interest" value={field.fname.l} onChange={(e) => handlechange('fname', 'l', e.target.value)} />

                                    </div>
                                </div>
                                <div className="newdeffields">
                                    <div className="fieldflex" >

                                        <div className="deffieldssub mainl">
                                            <label for="coding">category :</label>
                                        </div>
                                        <div className="deffieldssub">
                                            <label for="coding5">Show</label>
                                            <input type="checkbox" id="coding5" checked={field.cat.s == "1" ? true : false} name="interest" value="coding" onChange={(e) => handlechange('cat', 's', e.target.checked ? "1" : "0")} />

                                        </div>
                                        <div className="deffieldssub">
                                            <label for="coding6">Is required</label>
                                            <input type="checkbox" id="coding6" checked={field.cat.r == "1" ? true : false} name="interest" value="coding" onChange={(e) => handlechange('cat', 'r', e.target.checked ? "1" : "0")} />

                                        </div>
                                    </div>
                                    <div className="deffieldssub inptext">
                                        <label for="coding">Change label name</label>
                                        <input type="text" id="coding" name="interest" value={field.cat.l} onChange={(e) => handlechange('cat', 'l', e.target.value)} />

                                    </div>
                                </div>
                                <div className="newdeffields">
                                    <div className="fieldflex" >
                                        <div className="deffieldssub mainl">
                                            <label for="coding">Detail :</label>
                                        </div>
                                        <div className="deffieldssub">
                                            <label for="coding7">Show</label>
                                            <input type="checkbox" id="coding7" checked={field.detail.s == "1" ? true : false} name="interest" value="coding" onChange={(e) => handlechange('detail', 's', e.target.checked ? "1" : "0")} />

                                        </div>
                                        <div className="deffieldssub">
                                            <label for="coding8">Is required</label>
                                            <input type="checkbox" id="coding8" checked={field.detail.r == "1" ? true : false} name="interest" value="coding" onChange={(e) => handlechange('detail', 'r', e.target.checked ? "1" : "0")} />

                                        </div>
                                    </div>
                                    <div className="deffieldssub inptext">
                                        <label for="coding">Change label name</label>
                                        <input type="text" id="coding" name="interest" value={field.detail.l} onChange={(e) => handlechange('detail', 'l', e.target.value)} />

                                    </div>
                                </div>
                                <div className="newdeffields">
                                    <div className="fieldflex" >                                <div className="deffieldssub mainl">
                                        <label for="coding">T-Name :</label>
                                    </div>
                                        <div className="deffieldssub">
                                            <label for="coding9">Show</label>
                                            <input type="checkbox" id="coding9" checked={field.tname.s == "1" ? true : false} name="interest" value="coding" onChange={(e) => handlechange('tname', 's', e.target.checked ? "1" : "0")} />

                                        </div>
                                        <div className="deffieldssub">
                                            <label for="coding10">Is required</label>
                                            <input type="checkbox" id="coding10" checked={field.tname.r == "1" ? true : false} name="interest" value="coding" onChange={(e) => handlechange('tname', 'r', e.target.checked ? "1" : "0")} />

                                        </div>
                                    </div>
                                    <div className="deffieldssub inptext">
                                        <label for="coding">Change label name</label>
                                        <input type="text" id="coding" name="interest" value={field.tname.l} onChange={(e) => handlechange('tname', 'l', e.target.value)} />

                                    </div>
                                </div>
                                <div className="newdeffields">
                                    <div className="fieldflex" >                                        <div className="deffieldssub mainl">
                                        <label for="coding">Jerssey Number :</label>
                                    </div>
                                        <div className="deffieldssub">
                                            <label for="coding11">Show</label>
                                            <input type="checkbox" id="coding11" checked={field.tno.s == "1" ? true : false} name="interest" value="coding" onChange={(e) => handlechange('tno', 's', e.target.checked ? "1" : "0")} />

                                        </div>
                                        <div className="deffieldssub">
                                            <label for="coding12">Is required</label>
                                            <input type="checkbox" id="coding12" checked={field.tno.r == "1" ? true : false} name="interest" value="coding" onChange={(e) => handlechange('tno', 'r', e.target.checked ? "1" : "0")} />

                                        </div>
                                    </div>
                                    <div className="deffieldssub inptext">
                                        <label for="coding">Change label name</label>
                                        <input type="text" id="coding" name="interest" value={field.tno.l} onChange={(e) => handlechange('tno', 'l', e.target.value)} />

                                    </div>
                                </div>
                                <div className="newdeffields">
                                    <div className="fieldflex" >                                <div className="deffieldssub mainl">
                                        <label for="coding">T-shirt size  :</label>
                                    </div>
                                        <div className="deffieldssub">
                                            <label for="coding13">Show</label>
                                            <input type="checkbox" id="coding13" checked={field.tshirt.s == "1" ? true : false} name="interest" value="coding" onChange={(e) => handlechange('tshirt', 's', e.target.checked ? "1" : "0")} />

                                        </div>
                                        <div className="deffieldssub">
                                            <label for="coding14">Is required</label>
                                            <input type="checkbox" id="coding14" checked={field.tshirt.r == "1" ? true : false} name="interest" value="coding" onChange={(e) => handlechange('tshirt', 'r', e.target.checked ? "1" : "0")} />

                                        </div>
                                    </div>
                                    <div className="deffieldssub inptext">
                                        <label for="coding">Change label name</label>
                                        <input type="text" id="coding" name="interest" value={field.tshirt.l} onChange={(e) => handlechange('tshirt', 'l', e.target.value)} />

                                    </div>
                                </div>
                                <div className="newdeffields">
                                    <div className="fieldflex" >                                  <div className="deffieldssub mainl">
                                        <label for="coding">Trouser :</label>
                                    </div>
                                        <div className="deffieldssub">
                                            <label for="coding15">Show</label>
                                            <input type="checkbox" id="coding15" checked={field.trouser.s == "1" ? true : false} name="interest" value="coding" onChange={(e) => handlechange('trouser', 's', e.target.checked ? "1" : "0")} />

                                        </div>
                                        <div className="deffieldssub">
                                            <label for="coding16">Is required</label>
                                            <input type="checkbox" id="coding16" checked={field.trouser.r == "1" ? true : false} name="interest" value="coding" onChange={(e) => handlechange('trouser', 'r', e.target.checked ? "1" : "0")} />

                                        </div>
                                    </div>
                                    <div className="deffieldssub inptext">
                                        <label for="coding">Change label name</label>
                                        <input type="text" id="coding" name="interest" value={field.trouser.l} onChange={(e) => handlechange('trouser', 'l', e.target.value)} />

                                    </div>
                                </div>
                                <div className="newdeffields">
                                    <div className="fieldflex" >                                  <div className="deffieldssub mainl">
                                        <label for="coding">Icon :</label>
                                    </div>
                                        <div className="deffieldssub">
                                            <label for="coding17">Show</label>
                                            <input type="checkbox" id="coding17" checked={field.icon.s == "1" ? true : false} name="interest" value="coding" onChange={(e) => handlechange('icon', 's', e.target.checked ? "1" : "0")} />

                                        </div>
                                        <div className="deffieldssub">
                                            <label for="coding18">Is required</label>
                                            <input type="checkbox" id="coding18" checked={field.icon.r == "1" ? true : false} name="interest" value="coding" onChange={(e) => handlechange('icon', 'r', e.target.checked ? "1" : "0")} />

                                        </div>
                                    </div>
                                    <div className="deffieldssub inptext">
                                        <label for="coding">Change label name</label>
                                        <input type="text" id="coding" name="interest" value={field.icon.l} onChange={(e) => handlechange('icon', 'l', e.target.value)} />

                                    </div>
                                </div>
                                <div className="newdeffields">
                                    <div className="fieldflex" >                                      <div className="deffieldssub mainl">
                                        <label for="coding">Specification 1 :</label>
                                    </div>
                                        <div className="deffieldssub">
                                            <label for="coding19">Show</label>
                                            <input type="checkbox" id="coding19" checked={field.sp1.s == "1" ? true : false} name="interest" value="coding" onChange={(e) => handlechange('sp1', 's', e.target.checked ? "1" : "0")} />

                                        </div>
                                        <div className="deffieldssub">
                                            <label for="coding20">Is required</label>
                                            <input type="checkbox" id="coding20" checked={field.sp1.r == "1" ? true : false} name="interest" value="coding" onChange={(e) => handlechange('sp1', 'r', e.target.checked ? "1" : "0")} />

                                        </div>
                                    </div>
                                    <div className="deffieldssub inptext">
                                        <label for="coding">Change label name</label>
                                        <input type="text" id="coding" name="interest" value={field.sp1.l} onChange={(e) => handlechange('sp1', 'l', e.target.value)} />

                                    </div>
                                </div>
                                <div className="newdeffields">
                                    <div className="fieldflex" >                                   <div className="deffieldssub mainl">
                                        <label for="coding">Specification 2 :</label>
                                    </div>
                                        <div className="deffieldssub">
                                            <label for="coding21">Show</label>
                                            <input type="checkbox" id="coding21" checked={field.sp2.s == "1" ? true : false} name="interest" value="coding" onChange={(e) => handlechange('sp2', 's', e.target.checked ? "1" : "0")} />

                                        </div>
                                        <div className="deffieldssub">
                                            <label for="coding22">Is required</label>
                                            <input type="checkbox" id="coding22" checked={field.sp2.r == "1" ? true : false} name="interest" value="coding" onChange={(e) => handlechange('sp2', 'r', e.target.checked ? "1" : "0")} />

                                        </div>
                                    </div>
                                    <div className="deffieldssub inptext">
                                        <label for="coding">Change label name</label>
                                        <input type="text" id="coding" name="interest" value={field.sp2.l} onChange={(e) => handlechange('sp2', 'l', e.target.value)} />

                                    </div>
                                </div>
                                <div className="newdeffields">
                                    <div className="fieldflex" >                                 <div className="deffieldssub mainl">
                                        <label for="coding">Specification 3 :</label>
                                    </div>
                                        <div className="deffieldssub">
                                            <label for="coding23">Show</label>
                                            <input type="checkbox" id="coding23" checked={field.sp3.s == "1" ? true : false} name="interest" value="coding" onChange={(e) => handlechange('sp3', 's', e.target.checked ? "1" : "0")} />

                                        </div>
                                        <div className="deffieldssub">
                                            <label for="coding24">Is required</label>
                                            <input type="checkbox" id="coding24" checked={field.sp3.r == "1" ? true : false} name="interest" value="coding" onChange={(e) => handlechange('sp3', 'r', e.target.checked ? "1" : "0")} />

                                        </div>
                                    </div>
                                    <div className="deffieldssub inptext">
                                        <label for="coding">Change label name</label>
                                        <input type="text" id="coding" name="interest" value={field.sp3.l} onChange={(e) => handlechange('sp3', 'l', e.target.value)} />

                                    </div>
                                </div>
                                <div className="newdeffields">
                                    <div className="fieldflex" >                                <div className="deffieldssub mainl">
                                        <label for="coding">Receipt :</label>
                                    </div>
                                        <div className="deffieldssub">
                                            <label for="coding25">Show</label>
                                            <input type="checkbox" id="coding25" checked={field.receipt.s == "1" ? true : false} name="interest" onChange={(e) => handlechange('receipt', 's', e.target.checked ? "1" : "0")} />

                                        </div>
                                        <div className="deffieldssub">
                                            <label for="coding26">Is required</label>
                                            <input type="checkbox" id="coding26" checked={field.receipt.r == "1" ? true : false} name="interest" onChange={(e) => handlechange('receipt', 'r', e.target.checked ? "1" : "0")} />

                                        </div>
                                    </div>
                                    <div className="deffieldssub inptext">
                                        <label for="coding">Change label name</label>
                                        <input type="text" id="coding" name="interest" value={field.receipt.l} onChange={(e) => handlechange('receipt', 'l', e.target.value)} />

                                    </div>
                                </div>
                                <div className="deffieldsmain">

                                    {cuslist && cuslist.map((ele, index) => {


                                        return (
                                            <div className="newdeffields cusfields">
                                                <div className="half-field">
                                                    <div className="fieldflex" >
                                                        <div className="deffieldssub inptext">
                                                            <label for={"coding"+index}>Label</label>
                                                            <input type="text" id={"coding"+index} name="interest" value={ele.l} onChange={(e) => updcustlbl(index, e.target.value)} />

                                                        </div>

                                                    </div>

                                                    <div className="fieldflex" >

                                                        <div className="deffieldssub">
                                                            <label for="coding">Show</label>
                                                            <input type="checkbox" id="coding" name="interest" checked={ele.s == "1" ? true : false} onChange={(e) => updcusts(index, e.target.checked == true ? "1" : "0")} />

                                                        </div>
                                                        <div className="deffieldssub">
                                                            <label for="coding">Is required</label>
                                                            <input type="checkbox" id="coding" name="interest" checked={ele.r == "1" ? true : false} onChange={(e) => updcustreq(index, e.target.checked == true ? "1" : "0")} />

                                                        </div>

                                                    </div>
                                                </div>
                                                <div className="semi-half-field">
                                                    <div>
                                                        <label>

                                                            Text
                                                            <input
                                                                type="radio"
                                                                value="0"
                                                                checked={(ele.t && ele.t == '0')}
                                                                onChange={(e) => updinptype(index, '0')}
                                                            />
                                                        </label>
                                                    </div>
                                                    <div>
                                                        <label>

                                                            Number
                                                            <input
                                                                type="radio"
                                                                value="1"
                                                                checked={(ele.t && ele.t == '1')}
                                                                onChange={(e) => updinptype(index, '1')}
                                                            />
                                                        </label>
                                                    </div>
                                                    <div>
                                                    {ele.o && <><FontAwesomeIcon className="joinedit" onClick={()=>{setisoptpopup(true);setoptval(ele.o)}} icon={faPenToSquare} />&nbsp;</>}
                                                        <label>

                                                            Options
                                                            <input
                                                                type="radio"
                                                                value="2"
                                                                checked={(ele.t && ele.t == '2')}
                                                                onChange={(e) => updinptype(index, '2')}
                                                            />
                                                        </label>
                                                    </div>
                                                    {isoptpopup &&
                                                        <>
                                                            <div className="optionpopupbox">
                                                                Enter comma seperated options like : Option1,Option2,Option3 <input type="text" value={optval} onChange={(e) => setoptval(e.target.value)} />
                                                                <div className="okclosebtns">
                                                                    <button onClick={() => setisoptpopup(false)}>Close</button>
                                                                    <button onClick={(e) => updopt(index, optval)} >Set</button>
                                                                </div>
                                                            </div>

                                                        </>
                                                    }
                                                    <div><FontAwesomeIcon className="custrash" onClick={() => delcustom(index)} icon={faTrash} /></div>

                                                </div>
                                            </div>
                                        )
                                    })}
                                </div>
                                <div className="deffieldsmain">

                                    <button onClick={() => addcustomfield()} className="mydesbtn mycustombtn">+ Custom field</button>
                                </div>

                            </div>
                            <div style={{ textAlign: 'center' }}>

                                <button className=" cusformbtn" onClick={() => postfield()}>Submit</button>
                            </div>
                        </div>
                    </div>
                </div>
            </loadingOverlay>
        </>
    );
}

export default JoinauctionCode;
